<script lang="ts">
  import { WandSparkles, X } from '@lucide/svelte'
  import { featureFlags, type FeatureFlags } from '../../stores/feature-flags'

  let hidden = $state(true)
</script>

{#if !$featureFlags.demoMode && (import.meta.env.DEV || import.meta.env.VITE_ENABLE_FEATURE_FLAGS_DEVTOOLS)}
  <div class="container">
    {#if hidden}
      <button
        class="open-button"
        class:active={Object.values($featureFlags).some(value => value)}
        onclick={() => {
          hidden = false
        }}
      >
        <WandSparkles />
      </button>
    {:else}
      <div class="content-container">
        <div class="title">
          Feature Flags
          <button
            class="close-button"
            onclick={() => {
              hidden = true
            }}
          >
            <X />
          </button>
        </div>
        {#each Object.keys($featureFlags) as (keyof FeatureFlags)[] as featureFlagKey (featureFlagKey)}
          <div
            class="feature-flag-item"
            class:active={$featureFlags[featureFlagKey]}
          >
            <label for={featureFlagKey}>{featureFlagKey}</label>
            <input
              type="checkbox"
              id={featureFlagKey}
              checked={$featureFlags[featureFlagKey]}
              onchange={(e) => {
                featureFlags.update(flags => ({
                  ...flags,
                  [featureFlagKey]: (e.target as HTMLInputElement).checked,
                }))
              }}
            />
          </div>
        {/each}
      </div>
    {/if}
  </div>
{/if}

<style>
  .container {
    position: fixed;
    bottom: 4.25rem;
    right: 1rem;

    .open-button {
      border-radius: 20rem;
      padding: 0.75rem;
      display: flex;
      box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
      border: none;
      box-sizing: border-box;
      transition: filter 0.3s ease;
      cursor: pointer;

      &.active {
        background-color: var(--text-success);
        color: var(--white);
      }

      &:hover {
        filter: brightness(0.9);
      }
    }

    .content-container {
      background: var(--background);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
      padding: 1rem;
      border-radius: 0.5rem;

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        gap: 2rem;

        .close-button {
          background: var(--background);
          display: flex;
          border: none;
          font-size: 0.5rem;
          box-sizing: border-box;
          cursor: pointer;
          padding: 0;
          margin: 0;
        }
      }

      .feature-flag-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;

        label {
          font-size: 0.875rem;
        }
      }
    }
  }
</style>
